import React, { Component } from 'react';
import { Alert, Spin } from 'antd';
import { VDSTransmissionStatisticsForm } from '../../forms';
import {
  generateStatisticsRequestToVDSXML,
  parseResponse,
} from '../../utils/vdsHelpers';
import { sendStatisticsRequestToVDS } from '../../actions/actionHelpers/endpoints';

export class VDSTransmissionStatisticsView extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: '',
      request: '',
      response: null,
    };
  }

  clearMessages = () => {
    this.setState({ error: '', request: '', response: null });
  };

  send = async (values) => {
    this.clearMessages();
    values.TransactionDateTimeProcessed =
      values.TransactionDateTime.toISOString().slice(0, 19);
    const xml = generateStatisticsRequestToVDSXML(values);
    this.setState({ loading: true, request: xml, response: null });
    try {
      const responseObject = await sendStatisticsRequestToVDS({ xml });
      const response = parseResponse(responseObject);
      this.setState({
        loading: false,
        error: response.error ? 'Viga andmete saatmisel VDS-i' : '',
        response,
      });
    } catch (error) {
      console.error(error);
      const response = { error: error.message };
      this.setState({
        loading: false,
        error: 'Viga andmete saatmisel VDS-i',
        response,
      });
    }
  };

  render() {
    const { loading, error, response, request } = this.state;

    return (
      <Spin spinning={loading}>
        <VDSTransmissionStatisticsForm
          onSubmit={this.send}
          request={request}
          response={response}
          onReset={this.clearMessages}
        >
          {!error && !!response && (
            <Alert message={'Andmed saadeti VDS-ile'} type="success" closable />
          )}
          {!!error && <Alert message={error} type="error" closable />}
        </VDSTransmissionStatisticsForm>
      </Spin>
    );
  }
}

export default VDSTransmissionStatisticsView;
